import { IMsg } from '_c/typings/model/im';
import { ActionTree } from 'vuex';
import { RootState } from '../../index';
import ImApi from '_c/business/api/im';
import { TChatStoreState } from './state';
import { logger } from '_c/util/logger';
import topicApi from '_c/business/api/topic';

export interface IReactionOptOptions {
  reactionId: string;
  channelId: string;
  message: IMsg;
  /** 是否需要将表态反选操作(默认需要) */
  needInvertSelect?: boolean;
}

const actions: ActionTree<TChatStoreState, RootState> = {
  async reactionOpt(state, {
    reactionId, channelId, message, needInvertSelect = true,
  }: IReactionOptOptions): Promise<boolean> {
    const { reactions } = message;
    if (reactions) {
      const isDel = reactions.reactionId.includes(reactionId);
      if (isDel && !needInvertSelect) {
        return true;
      }

      return ImApi.imReactionOpt({
        opt: isDel ? 2 : 1,
        reactionId,
        chanId: channelId,
        l2Type: message.l2Type,
        msgSeq: String(message?.origin?.sequence ?? ''),
      }).then(() => {
        const userReactionIndex = reactions.reactionId.indexOf(reactionId);
        const messageReactionIndex = reactions.list.findIndex(item => item.reactionId === reactionId);
        if (isDel) {
          // 先检查用户点赞列表
          if (userReactionIndex >= 0) {
            reactions.reactionId.splice(userReactionIndex, 1);

            // 再检查消息点赞列表
            if (messageReactionIndex >= 0) {
              const messageReactionItem = reactions.list[messageReactionIndex];
              // 只剩一个表态，那么就删除该 item
              if (Number(messageReactionItem.count) <= 1) {
                reactions.list.splice(messageReactionIndex, 1);
              } else {
                messageReactionItem.count = String(Number(messageReactionItem.count) - 1);
              }
            }
          }
        } else {
          if (userReactionIndex < 0) {
            reactions.reactionId.push(reactionId);

            if (messageReactionIndex >= 0) {
              const messageReactionItem = reactions.list[messageReactionIndex];
              messageReactionItem.count = String(Number(messageReactionItem.count) + 1);
            } else {
              reactions.list.push({
                channelId,
                reactionId,
                msgSeq: String(message?.origin?.sequence ?? ''),
                count: String(1),
                time: String(Math.floor((+new Date()) / 1000)),
              });
            }
          }
        }
        return isDel;
      });
    }
    logger.info('store-chat-reactionOpt', 'message.reactions error: ', message.reactions);
    throw `message.reactions error: ${reactions}`;
  },
  getTopicListInfo({ commit }, topicIdList: string[]) {
    topicApi.getTopicInfo(topicIdList).then((data) => {
      Object.keys(data.topicInfos).forEach((topicId) => {
        commit('setTopicInfoMap', { topicId, topicInfo: data.topicInfos[topicId] });
      });
    });
  },
};

export default actions;
